/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { auth } from '../_actions/chatbot_actions';
import {  useDispatch } from "react-redux";
import { useNavigate, Outlet } from 'react-router-dom';

export default function AuthenticationCheck(option) {
        
        const navigate = useNavigate();
        // let user = useSelector(state => state.admin);
        
        const dispatch = useDispatch();
        
        useEffect(() => {
            if(!option.authentication) return;
            
            const adminToken = window.localStorage.getItem('adminToken');

            if(adminToken) {

            //To know my current status, send Auth request 
            dispatch(auth({adminToken})).then(response => {

                //Not Loggined in Status 
                if (response.payload.data.code==='N') {
                    window.localStorage.removeItem();
                    return navigate(`/login`);
                 
                    //Loggined in Status 
                } else {
                    const adminInfo = response.payload.data.adminInfo
                    window.localStorage.setItem('manageCode', adminInfo.manage_code );
                    window.localStorage.setItem('id', adminInfo.admin_id );
                }
            }).catch((e) => {
                    if(e.response.data.code==='N') {
                        window.localStorage.setItem('manageCode', null );
                        window.localStorage.setItem('adminToken', null );
                        return navigate('/login');
                    }
            })

            } else {
                return navigate(`/login`);
            }
        

        }, [])
   
        return <Outlet />
    }
